exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._2NXPOXDsYoZiVIzZScBYf_1{position:absolute;top:0;right:0}", "", {"version":3,"sources":["/workspace/src/views/order-review/pages/OrderReviewInfoPanel/index.vue"],"names":[],"mappings":"AACA,0BAAO,kBAAkB,MAAM,OAAO,CACrC","file":"index.vue","sourcesContent":["\n.tools{position:absolute;top:0;right:0\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"tools": "_2NXPOXDsYoZiVIzZScBYf_1"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_1","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-25239045","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/order-review/pages/OrderReviewInfoPanel/index.vue
// module id = 4687
// module chunks = 5